export class EmotionalState {
  static UNDEFINED = -1;
  static SAD = 0;
  static AFRAID = 1;
  static BALANCED = 2;
  static HAPPY = 3;
  static VERY_HAPPY = 4;
}
